import {Box} from '@mantine/core'

import classes from './environment-banner.module.css'

export const ENVIRONMENT_BANNER_HEIGHT = 30

export function environmentBannerText(): string {
    return import.meta.env.VITE_ENVIRONMENT_BANNER?.trim() ?? ''
}

export function EnvironmentBanner({text}: {text: string}) {
    return (
        <Box className={classes['banner']} h={ENVIRONMENT_BANNER_HEIGHT} role="status">
            {text}
        </Box>
    )
}

export function PageEnvironmentBanner() {
    const text = environmentBannerText()
    return text ? <EnvironmentBanner text={text} /> : null
}
